export const inventorization_statuses = [
  { label: "Brak", value: null },
  { label: "W trakcie", value: "in_progress" },
  { label: "Zakończone", value: "completed" },
];

export const getInventorizationStatusLabel = (status) =>
  inventorization_statuses.find((s) => s.value === status)?.label;
